/**
 * An enum of all currency codes supported on the Vista platform.
 */
export enum CurrencyCode {
    AUD = 'AUD',
    CAD = 'CAD',
    CHF = 'CHF',
    DKK = 'DKK',
    EUR = 'EUR',
    GBP = 'GBP',
    SGD = 'SGD',
    USD = 'USD',
    INR = 'INR',
    SEK = 'SEK',
    NZD = 'NZD',
    BRL = 'BRL',
    NOK = 'NOK',

    // NOT supported. JPY is kept for tests.

    JPY = 'JPY',
    // MXN = 'MXN',
    // NOK = 'NOK',
    // HKD = 'HKD',
}
